import { useCallback, useEffect, useState } from "react";

import * as Pool from "../api/chain/pool";

import Store from "../../../stores/store";
import Web3 from "web3";
import { GET_STAKING_POOLS_INFO } from "../../../constants/constants";
import { useAccount } from "../../../contexts/AccountContext";
import {
  BUIDL_ETH_POOL_ADDRESS,
  BUIDL_USDC_POOL_ADDRESS,
  BUIDL_WETH_AERO_POOL_ADDRESS,
} from "../constants/constants";

const store = Store.store;
const dispatcher = Store.dispatcher;

export const usePools = () => {
  const { account } = useAccount();

  const [items, setItems] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [buidlUsdcPool, setBuidlUsdcPool] = useState(true);
  const [buidlEthPool, setBuidlEthPool] = useState(true);
  const [buidlWEthAEROPool, setBuidlWEthAEROPool] = useState(true);

  const getStakingPoolsReturned = useCallback(() => {
    const stakingPools = store.getStore("stakingPools");
    setItems(stakingPools);

    setBuidlUsdcPool(
      Object.values(stakingPools).find(
        ({ pool }) => pool === BUIDL_USDC_POOL_ADDRESS
      )
    );

    setBuidlEthPool(
      Object.values(stakingPools).find(
        ({ pool }) => pool === BUIDL_ETH_POOL_ADDRESS
      )
    );

    setBuidlWEthAEROPool(
      Object.values(stakingPools).find(
        ({ pool }) => pool === BUIDL_WETH_AERO_POOL_ADDRESS
      )
    );
    setLoading(false);
  }, []);

  useEffect(() => {
    getStakingPoolsReturned();

    const watchStakingPoolsChangeId = setInterval(() => {
      getStakingPoolsReturned();
    }, 1000);

    return () => {
      clearInterval(watchStakingPoolsChangeId);
    };
  }, [getStakingPoolsReturned]);

  const approve = useCallback(
    async (pool, amount = "9999999999") => {
      const web3 = new Web3(store.getStore("web3context").library.provider);
      if (!web3) {
        return;
      }

      await Pool.approvePool(
        web3,
        pool.token.address,
        pool.pool,
        account.address,
        Web3.utils.toWei(amount.toString())
      );
    },
    [account]
  );

  const stake = useCallback(
    async (pool, amount, lockUntil) => {
      const web3 = new Web3(store.getStore("web3context").library.provider);
      await Pool.approvePool(
        web3,
        pool.token.address,
        pool.pool,
        account.address,
        amount
      );
      await Pool.stake(web3, pool.pool, amount, lockUntil, account.address);
      dispatcher.dispatch({ type: GET_STAKING_POOLS_INFO, content: {} });
    },
    [account]
  );

  const claim = useCallback(
    async (pool) => {
      const web3 = new Web3(store.getStore("web3context").library.provider);
      await Pool.claim(web3, pool.pool, account.address);
      dispatcher.dispatch({ type: GET_STAKING_POOLS_INFO, content: {} });
    },
    [account]
  );

  return {
    items,
    buidlUsdcPool,
    buidlEthPool,
    buidlWEthAEROPool,
    isLoading,
    approve,
    stake,
    claim,
  };
};
